import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  repliesByEmailId: {},
  status: false,
  // Real-time reply notifications — shown in navbar until dismissed
  // Each entry: { id, leadId, messageId, from, subject, receivedAt, read }
  replyNotifications: [],
};

const emailRepliesSlice = createSlice({
  name: 'emailReplies',
  initialState,
  reducers: {
    setRepliesForEmail(state, action) {
      const { emailID, replies } = action.payload;
      state.repliesByEmailId[emailID] = replies;
    },
    clearReplies(state) {
      state.repliesByEmailId = {};
    },
    setStatus(state, action) {
      state.status = action.payload;
    },
    // Called when email:sesEvent { status: 'replied' } arrives via socket
    addReplyNotification(state, action) {
      const { leadId, messageId, from, subject, receivedAt } = action.payload;
      // Deduplicate by messageId — socket may fire multiple times
      if (!state.replyNotifications.some(n => n.messageId === messageId)) {
        state.replyNotifications.unshift({
          id:         `${messageId}-${Date.now()}`,
          leadId,
          messageId,
          from:       from || '',
          subject:    subject || '',
          receivedAt: receivedAt || new Date().toISOString(),
          read:       false,
        });
        // Cap at 50
        if (state.replyNotifications.length > 50) {
          state.replyNotifications = state.replyNotifications.slice(0, 50);
        }
      }
    },
    markReplyNotificationRead(state, action) {
      const n = state.replyNotifications.find(n => n.id === action.payload.id);
      if (n) n.read = true;
    },
    markAllReplyNotificationsRead(state) {
      state.replyNotifications.forEach(n => { n.read = true; });
    },
    clearReplyNotifications(state) {
      state.replyNotifications = [];
    },
  },
});

export const {
  setRepliesForEmail,
  clearReplies,
  setStatus,
  addReplyNotification,
  markReplyNotificationRead,
  markAllReplyNotificationsRead,
  clearReplyNotifications,
} = emailRepliesSlice.actions;

export default emailRepliesSlice.reducer;
